













import {Component, Mixins, Prop} from 'vue-property-decorator';
import Control from './Control';

@Component({watch: {numberValueRaw: 'updateValue'}})
export default class NumberControl extends Mixins<Control<number>>(Control) {
    @Prop({required: true})
    public readonly min: number | null;

    @Prop({required: true})
    public readonly unit: string | null;

    private numberValueRaw: string = '';

    public created(): void {
        if (this.value === null) {
            return;
        }

        this.numberValueRaw = '' + this.value;
    }

    protected validateCurrentValue(): boolean {
        const value = this.getValue();

        return value === null || (! isNaN(value) && (this.min === null || value >= this.min));
    }

    protected getValue(): number | null {
        if (this.numberValueRaw === '') {
            return null;
        }

        if (! /^[0-9]+$/.test(this.numberValueRaw)) {
            return NaN;
        }

        return Number.parseInt(this.numberValueRaw, 10);
    }
}
